import React, { useState, useEffect, useRef } from "react";
import { useParams, useNavigate } from "react-router-dom";
import axios from "axios";
import Clock from "../components/Clock";
import { DAppClient, NetworkType } from "@airgap/beacon-sdk";
import { TezosToolkit } from "@taquito/taquito";
import { BeaconWallet } from "@taquito/beacon-wallet";
import CryptoJS from "crypto-js";
import { createHistory } from "../../Common/createHistory";
import CustomToastContainer from "../../Common/CustomToastContainer";
import { io } from "socket.io-client";

// Create a single socket connection
const socket = io(process.env.REACT_APP_SOCKET_SERVER_URL, {
  transports: ["websocket"],
  reconnection: true,
  reconnectionAttempts: 5,
  reconnectionDelay: 1000,
});

const ITEMS_PER_PAGE = 8;

const tezos = new TezosToolkit(process.env.REACT_APP_RPC_URL); // or use a custom RPC endpoint

const wallet = new BeaconWallet({
  name: "ArtCollect",
  preferredNetwork: NetworkType.GHOSTNET, // or GHOSTNET
});

tezos.setWalletProvider(wallet);
const domainpath = process.env.REACT_APP_API_DOMAIN_ENDPOINT;
const SECRET_KEY =
  "0123456789abcdef0123456789abcdef0123456789abcdef0123456789abcdef"; // Same key used for encryption
const ENCRYPTION_ALGORITHM = CryptoJS.AES; // Using AES for encryption

// Function to decrypt data
function decrypt(encryptedText) {
  // Split the encrypted text to get IV and encrypted data
  const [ivHex, encryptedData] = encryptedText.split(":");

  // Convert IV and encrypted data from hex to word arrays
  const iv = CryptoJS.enc.Hex.parse(ivHex);
  const encryptedDataBytes = CryptoJS.enc.Hex.parse(encryptedData);

  // Decrypt the data
  const decryptedData = ENCRYPTION_ALGORITHM.decrypt(
    { ciphertext: encryptedDataBytes },
    CryptoJS.enc.Hex.parse(SECRET_KEY),
    { iv: iv }
  );

  // Convert decrypted bytes to UTF-8 string
  return decryptedData.toString(CryptoJS.enc.Utf8);
}

const AuthorProfile = () => {
  const toastRef = useRef();
  const [nfts, setnfts] = useState([]);
  const [userAddress, setUserAddress] = useState();
  const [bidAmount, setBidAmount] = useState("");
  const [render, setRender] = useState(0);
  const [isFollowing, setIsFollowing] = useState(false);
  const [showBidModal, setShowBidModal] = useState(false);
  const [showMakeModal, setshowMakeModal] = useState(false);
  const [selectedNFT, setSelectedNFT] = useState(null);
  const [bidError, setBidError] = useState(false);
  const [Loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const [sellerData, setSellerData] = useState({
    name: "",
    balance: 0,
    avatar: "",
    createdItems: [],
    ownedItems: [],
    collections: [],
    activity: [],
    offers: [],
    listings: [],
    liked: [],
    onsale: [],
    auctions: [],
  });
  const [loading, setloading] = useState(false);
  const [activeTab, setActiveTab] = useState("created");
  const [currentPage, setCurrentPage] = useState({
    created: 1,
    owned: 1,
    collections: 1,
    activity: 1,
    offers: 1,
    liked: 1,
    onsale: 1,
    listings: 1,
    auctions: 1,
  });
  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleDateString("en-US", {
      year: "numeric",
      month: "long",
      day: "numeric",
    });
  };
  useEffect(() => {
    const storedAddress = localStorage.getItem("walletAddress");
    if (storedAddress) {
      setUserAddress(storedAddress);
    }

    const fetchSellerProfile = async (userAddress) => {
      if (!userAddress) {
        toastRef.current.addToast(
          "Please connect your Temple Wallet.",
          "warning"
        );

        try {
          // 1. First check if wallet is connected without forcing permissions
          const activeAccount = await wallet.client.getActiveAccount();

          if (!activeAccount) {
            // 2. Only request permissions if no active account exists
            await wallet.requestPermissions({
              forcePermissionRequest: true, // Ensures modal shows
            });
          }

          // 3. Get address after successful connection
          const address = await wallet.getPKH();
          setUserAddress(address);
          localStorage.setItem("walletAddress", address);

          // 4. Optional: reload only if absolutely necessary
          if (!window.location.search.includes("fromConnect")) {
            window.location.reload();
          }
        } catch (error) {
          console.error("Connection error:", error);
          toastRef.current.addToast(
            "Failed to connect wallet. Please try again.",
            "error"
          );
        }
        return;
      }

      try {
        setloading(true);
        const response = await axios.get(
          `${process.env.REACT_APP_API_DOMAIN_ENDPOINT}/api/user/profile?address=${userAddress}`
        );

        const data = response.data;
        console.log(data, "data");

        const profile = data.profile || {};
        const activity = data.activity || [];
        const collections = data.collections || [];

        // Group NFTs by base_id and filter next unsold edition
        const getFilteredByBaseId = (nfts = []) => {
          const grouped = {};
          for (const nft of nfts) {
            const baseId = nft.blockchain_metadata?.base_id;
            if (!baseId) continue;
            if (!grouped[baseId]) grouped[baseId] = [];
            grouped[baseId].push(nft);
          }

          const result = [];
          for (const baseId in grouped) {
            const editions = grouped[baseId];
            editions.sort(
              (a, b) =>
                +a.blockchain_metadata.edition - +b.blockchain_metadata.edition
            );
            const nextAvailable = editions.find(
              (nft) => !nft.sale_status && !nft.buyer
            );
            if (nextAvailable) result.push(nextAvailable);
          }

          return result;
        };
        const getFilteredCreatedByBaseId = (nfts = []) => {
          const grouped = {};
          for (const nft of nfts) {
            const baseId = nft.blockchain_metadata?.base_id;
            if (!baseId) continue;
            if (!grouped[baseId]) grouped[baseId] = [];
            grouped[baseId].push(nft);
          }

          const result = [];
          for (const baseId in grouped) {
            const editions = grouped[baseId];
            editions.sort(
              (a, b) =>
                +a.blockchain_metadata.edition - +b.blockchain_metadata.edition
            );

            // Add all sold editions (could be more than one)
            const sold = editions.filter((nft) => nft.sale_status || nft.buyer);
            result.push(...sold);

            // Add only one next unsold edition (the first one that is unsold)
            const nextAvailable = editions.find(
              (nft) => !nft.sale_status && !nft.buyer
            );
            if (nextAvailable) result.push(nextAvailable);
          }

          return result;
        };

        // Apply filtering
        const filteredCreated = getFilteredCreatedByBaseId(data.created || []);
        const filteredOwned = getFilteredByBaseId(data.owned || []);
        const filteredAll = getFilteredByBaseId(data.all || []);
        const allNfts = data?.all || [];
        const liked = data.liked || [];
        const onSaleItems = allNfts.filter(
          (nft) => nft?.blockchain_metadata?.open_to_sell === true
        );
        setnfts(filteredAll);
        const avatar = profile.profileImage
          ? profile.profileImage
          : `${process.env.REACT_APP_GENERATE_AVATAR_URL}/${userAddress}.png?size=200x200`;

        setSellerData({
          name:
            profile.username ||
            `${userAddress.slice(0, 6)}...${userAddress.slice(-4)}`,
          balance: profile.balance ? profile.balance / 1_000_000 : 0,
          avatar: avatar,
          createdItems: filteredCreated,
          ownedItems: filteredOwned,
          collections,
          activity,
          liked,
          onsale: onSaleItems,
          offers: [],
          listings: [],
          auctions: [],
          followers: response.data.followers,
          following: response.data.following,
        });
      } catch (error) {
        console.error("Failed to fetch seller profile:", error);
      } finally {
        setloading(false);
      }
    };

    fetchSellerProfile(storedAddress);
  }, [userAddress]);

  const handlePlaceBid = async () => {
    setloading(true);

    // Validate bid amount
    if (!bidAmount || isNaN(bidAmount) || bidAmount <= 0) {
      toastRef.current.addToast("Please enter a valid bid amount.", "warning");
      setloading(false);
      return;
    }

    try {
      // Request wallet permissions
      await wallet.requestPermissions();
      const userAddress = await wallet.getPKH();

      if (!userAddress) {
        toastRef.current.addToast("Wallet connection failed.", "error");
        setloading(false);
        return;
      }
      const storedAddress = localStorage.getItem("walletAddress");
      if (!storedAddress || storedAddress !== userAddress) {
        localStorage.setItem("walletAddress", userAddress);
      }
      // Get contract and decrypt NFT ID
      const contract = await tezos.wallet.at(
        process.env.REACT_APP_CONTRACT_ADDRESS
      );
      const nft_id = decrypt(selectedNFT.nft_id);

      // Convert to mutez (1 ꜩ = 1,000,000 mutez)
      const mutezAmount = Math.floor(Number(bidAmount) * 1_000_000);

      toastRef.current.addToast(
        "Please confirm the bid in your wallet...",
        "info"
      );
      const platformFeePercent = parseFloat(
        process.env.REACT_APP_PLATFORM_FEE || "2.5"
      );
      const platformFeeMutez = Math.floor(
        bidAmount * (platformFeePercent / 100)
      );
      // Call the bidactn entry point
      const op = await contract.methods
        .bidactn(nft_id, platformFeeMutez)
        .send({ amount: bidAmount });

      toastRef.current.addToast(
        "Bid placed! Waiting for confirmation...",
        "info"
      );

      await op.confirmation(1); // wait for 1 block confirmation
      socket.emit("new-bid", {
        ownerWallet: selectedNFT.blockchain_metadata.owner,
        bidderWallet: userAddress,
        amount: bidAmount,
        itemName: selectedNFT.blockchain_metadata.name,
        itemId: selectedNFT._id,
      });
      toastRef.current.addToast("Bid placed successfully!", "success");
      setShowBidModal(false);
      setBidAmount("");
      setRender(render + 1); // Refresh data
    } catch (error) {
      //console.error("Error placing bid:", error);

      let errorMessage = "Failed to place bid";
      if (error.message.includes("Auction does not exist")) {
        errorMessage = "Auction not found";
      } else if (error.message.includes("Auction has ended")) {
        errorMessage = "Auction has already ended";
      } else if (error.message.includes("Bid must be higher")) {
        errorMessage = "Your bid must be higher than current highest bid";
      } else if (error.message.includes("user rejected")) {
        errorMessage = "Transaction was cancelled";
      }

      toastRef.current.addToast(errorMessage, "error");
    } finally {
      setloading(false);
    }
  };
  const handleBidChange = (e, currentBid) => {
    // console.log(currentBid);

    const value = e.target.value;
    setBidAmount(value);

    const parsedValue = parseFloat(value);
    if (!isNaN(parsedValue) && parsedValue > currentBid) {
      setBidError(false);
    } else {
      setBidError(true);
    }
  };
  const handleBuyNow = async (nft) => {
    try {
      setloading(true);
      // 1) Request wallet permissions
      await wallet.requestPermissions();
      const userAddress = await wallet.getPKH();

      if (!userAddress) {
        toastRef.current.addToast("Wallet connection failed.", "error");
        setloading(false);
        return;
      }

      // Store address in localStorage if not already present
      const storedAddress = localStorage.getItem("walletAddress");
      if (!storedAddress || storedAddress !== userAddress) {
        localStorage.setItem("walletAddress", userAddress);
      }

      if (userAddress === nft.blockchain_metadata.owner) {
        toastRef.current.addToast(
          "You already own this NFT — purchasing it again isn’t allowed.",
          "error"
        );
        setTimeout(() => {
          window.location.reload();
        }, 5000);

        return;
      } else {
        // 2) Get contract instance
        const contract = await tezos.wallet.at(
          process.env.REACT_APP_CONTRACT_ADDRESS
        );

        // 3) Decrypt NFT ID (assuming it's encrypted)
        const nftId = decrypt(nft.nft_id);

        if (!nftId || isNaN(nftId)) {
          toastRef.current.addToast("Invalid NFT ID.", "error");
          setloading(false);
          return;
        }

        // 4) Get platform fee and owner from env
        const platformFeePercent = parseFloat(
          process.env.REACT_APP_PLATFORM_FEE || "2.5" // Default to 2.5% if not set
        );
        const platformOwner = process.env.REACT_APP_PLATFORM_OWNER;

        if (!platformOwner) {
          toastRef.current.addToast("Platform owner not configured.", "error");
          setloading(false);
          return;
        }

        // 5) Calculate amounts (convert from mutez to tez)
        const nftPriceTez = toTez(nft.blockchain_metadata.price);
        const platformFeeTez = nftPriceTez * (platformFeePercent / 100);
        const totalAmountTez = nftPriceTez + platformFeeTez;

        // Convert back to mutez for the contract call
        const platformFeeMutez = Math.floor(platformFeeTez * 1000000);

        // 6) Call the contract with properly formatted parameters
        const op = await contract.methods
          .buynft(
            parseInt(nftId), // Ensure nft_id is a number
            platformOwner, // platform_owner address
            platformFeeMutez // platform_fee in mutez
          )
          .send({
            amount: totalAmountTez,
            mutez: false, // amount is in tez
          });

        // 7) Wait for confirmation
        await op.confirmation(1);
        // ✅ Emit socket event
        socket.emit("successful-purchase", {
          buyerWallet: userAddress,
          sellerWallet: nft.blockchain_metadata.owner,
          price: nftPriceTez,
          itemName: nft.blockchain_metadata.name,
          itemId: nft._id,
        });
        // 8) Create history record
        const historyData = {
          action: "buy",
          user: userAddress,
          nft_id: nftId,
          details: `${userAddress} purchased NFT #${nftId} for ${nftPriceTez} ꜩ`,
        };
        await createHistory(historyData);

        // 9) Success!
        toastRef.current.addToast(
          "Purchase completed successfully!",
          "success"
        );
        setRender((prev) => prev + 1); // Refresh the UI
      }
    } catch (error) {
      console.error("Buy Now Error:", error);

      let errorMessage = "Failed to complete purchase";
      if (error.message.includes("user rejected")) {
        errorMessage = "Transaction was cancelled";
      } else if (error.message.includes("NFT does not exist")) {
        errorMessage = "NFT no longer exists";
      } else if (error.message.includes("not for sale")) {
        errorMessage = "NFT is no longer for sale";
      } else if (error.message.includes("Insufficient funds")) {
        errorMessage = "Insufficient funds for purchase";
      } else if (error.message.includes("Invalid contract parameter")) {
        errorMessage = "Invalid transaction parameters";
      }
      setloading(false);
      toastRef.current.addToast(errorMessage, "error");
    } finally {
      setloading(false);
    }
  };
  const handleMakeOffer = async () => {
    console.log("Make Offer button clicked");
    setloading(true);

    try {
      // Directly request permissions
      await wallet.requestPermissions();
    } catch (err) {
      //console.error("Wallet permission error:", err); // Log the full error for debugging
      if (err.errorType === "ABORTED_ERROR") {
        toastRef.current.addToast(
          "Wallet connection was cancelled by the user.",
          "error"
        );
      } else {
        toastRef.current.addToast(
          err.message || "Wallet connection was rejected.",
          "error"
        );
      }
      setloading(false);
      return;
    }

    // 3) Get PKH with error handling
    let userAddress;
    try {
      userAddress = await wallet.getPKH();
    } catch (err) {
      //console.error("Wallet getPKH error:", err); // Log the full error for debugging
      if (
        err.errorType === "ABORTED_ERROR" ||
        err.name === "UnknownBeaconError" ||
        err.title === "Aborted"
      ) {
        toastRef.current.addToast(
          "Wallet connection was cancelled by the user.",
          "error"
        );
      } else {
        toastRef.current.addToast(
          err.message || "Wallet connection failed.",
          "error"
        );
      }
      setloading(false);
      return;
    }

    const storedAddress = localStorage.getItem("walletAddress");
    if (!storedAddress || storedAddress !== userAddress) {
      localStorage.setItem("walletAddress", userAddress);
    }
    // 5) Build & Send Transaction
    let op;
    try {
      const contract = await tezos.wallet.at(
        process.env.REACT_APP_CONTRACT_ADDRESS
      );
      //console.log(selectedNFT, "selectedNFT");

      const nftId = decrypt(selectedNFT.nft_id);
      const receiverWallet = selectedNFT.blockchain_metadata?.owner;
      const platformFeePercent = parseFloat(
        process.env.REACT_APP_PLATFORM_FEE || "0"
      );
      const platformOwner = process.env.REACT_APP_PLATFORM_OWNER;

      if (!platformOwner || isNaN(platformFeePercent)) {
        throw new Error("Platform fee or owner is not configured properly.");
      }

      // ✅ Calculate platform fee as amount * (feePercent / 100)
      const platformFeeMutez = Math.floor(
        bidAmount * (platformFeePercent / 100)
      );
      //console.log(nftId, userAddress, platformOwner, platformFeeMutez);

      op = await contract.methods
        .makeoffer(nftId, userAddress, platformOwner, platformFeeMutez)
        .send({ amount: bidAmount });
      const historyData = {
        action: "offer",
        user: userAddress,
        nft_id: nftId,
        details: `${userAddress} made an offer of ${bidAmount} ꜩ on NFT #${nftId}`,
      };
      await createHistory(historyData);
      socket.emit("make-offer", {
        senderWallet: userAddress,
        receiverWallet: receiverWallet,
        nftId: selectedNFT._id,
        nftName: selectedNFT.title || `NFT #${nftId}`,
        offerAmount: bidAmount,
        timestamp: new Date().toISOString(),
      });
      window.location.reload();
    } catch (err) {
      //console.error("Transaction send error:", err); // Log the full error for debugging
      const msg = err.message || "Failed to send offer transaction.";
      const isAbort =
        err.errorType === "ABORTED_ERROR" ||
        err.name === "UnknownBeaconError" ||
        msg.toLowerCase().includes("user rejected");
      toastRef.current.addToast(
        isAbort ? "Transaction was cancelled by the user." : msg,
        "error"
      );
      setloading(false);
      return;
    }

    toastRef.current.addToast(
      "Transaction sent! Waiting for confirmation...",
      "info"
    );

    // 6) Wait for confirmation
    try {
      await op.confirmation(1);
    } catch (err) {
      //console.error("Transaction confirmation error:", err); // Log the full error for debugging
      toastRef.current.addToast(
        err.message || "Transaction confirmation failed.",
        "error"
      );
      setloading(false);
      return;
    }

    // 7) Success!
    toastRef.current.addToast("Offer placed successfully!", "success");
    setshowMakeModal(false);
    setBidAmount("");
    setRender((r) => r + 1);
    setloading(false);
  };
  const toggleLike = async (artId, liked, nftid, artOwnerWallet, nftName) => {
    if (!userAddress) {
      try {
        // 1. First check if wallet is connected without forcing permissions
        const activeAccount = await wallet.client.getActiveAccount();

        if (!activeAccount) {
          // 2. Only request permissions if no active account exists
          await wallet.requestPermissions({
            forcePermissionRequest: true, // Ensures modal shows
          });
        }

        // 3. Get address after successful connection
        const address = await wallet.getPKH();
        setUserAddress(address);
        localStorage.setItem("walletAddress", address);

        try {
          const url = `${domainpath}/api/art/${artId}/${
            liked ? "unlike" : "like"
          }`;
          const response = await fetch(url, {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify({ userId: userAddress }), // Send user ID
          });
          const nftId = decrypt(nftid);
          const likerName = `${userAddress.slice(0, 6)}...${userAddress.slice(
            -4
          )}`;

          const historyData = {
            action: liked ? "unlike" : "like",
            user: userAddress,
            details: `${userAddress} ${
              liked ? "unlike" : "like"
            } art with ID ${artId}`,
            nft_id: nftId,
          };
          await createHistory(historyData);
          if (!response.ok) throw new Error("Failed to update like status");

          const updatedArt = await response.json();
          socket.emit(liked ? "unlike-art" : "like-art", {
            likerName,
            likerWallet: userAddress,
            ownerWallet: artOwnerWallet,
            nftId: artId,
            nftName: nftName || `NFT #${nftId}`,
            timestamp: new Date().toISOString(),
          });
          // Update the specific artwork in the state
          setnfts((prevArts) =>
            prevArts.map((art) =>
              art.id === artId
                ? {
                    ...art,
                    likeCount: updatedArt.likeCount,
                    likedByUser: !liked,
                  }
                : art
            )
          );
        } catch (error) {
          //console.error("Error liking/unliking art:", error);
        }
        window.location.reload();
      } catch (error) {
        console.error("Connection error:", error);
        toastRef.current.addToast(
          "Failed to connect wallet. Please try again.",
          "error"
        );
      }
      return;
    } else {
      try {
        const url = `${domainpath}/api/art/${artId}/${
          liked ? "unlike" : "like"
        }`;
        const response = await fetch(url, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ userId: userAddress }), // Send user ID
        });
        const nftId = decrypt(nftid);
        const likerName = `${userAddress.slice(0, 6)}...${userAddress.slice(
          -4
        )}`;

        const historyData = {
          action: liked ? "unlike" : "like",
          user: userAddress,
          details: `${userAddress} ${
            liked ? "unlike" : "like"
          } art with ID ${artId}`,
          nft_id: nftId,
        };
        await createHistory(historyData);
        if (!response.ok) throw new Error("Failed to update like status");

        const updatedArt = await response.json();
        socket.emit(liked ? "unlike-art" : "like-art", {
          likerName,
          likerWallet: userAddress,
          ownerWallet: artOwnerWallet,
          nftId: artId,
          nftName: nftName || `NFT #${nftId}`,
          timestamp: new Date().toISOString(),
        });
        // Update the specific artwork in the state
        setnfts((prevArts) =>
          prevArts.map((art) =>
            art.id === artId
              ? { ...art, likeCount: updatedArt.likeCount, likedByUser: !liked }
              : art
          )
        );
      } catch (error) {
        //console.error("Error liking/unliking art:", error);
      }
    }
  };
  const handleOpenItem = (nftLink) => {
    setloading(true);

    setTimeout(() => {
      window.open(nftLink, "_self");
      setloading(false);
    }, 1000);
  };

  const openBidModal = async (nft) => {
    if (!userAddress) {
      try {
        // 1. First check if wallet is connected without forcing permissions
        const activeAccount = await wallet.client.getActiveAccount();

        if (!activeAccount) {
          // 2. Only request permissions if no active account exists
          await wallet.requestPermissions({
            forcePermissionRequest: true, // Ensures modal shows
          });
        }

        // 3. Get address after successful connection
        const address = await wallet.getPKH();
        setUserAddress(address);
        localStorage.setItem("walletAddress", address);
        if (nft?.blockchain_metadata.owner === address) {
          toastRef.current.addToast(
            "Oops! You already own this artwork — place a bid isn’t necessary.",
            "error"
          );

          window.location.reload();
        } else {
          setSelectedNFT(nft);
          setShowBidModal(true);
        }
      } catch (error) {
        console.error("Connection error:", error);
        toastRef.current.addToast(
          "Failed to connect wallet. Please try again.",
          "error"
        );
      }
      return;
    } else {
      setSelectedNFT(nft);
      setShowBidModal(true);
    }
  };
  const openMakeofferModal = async (nft) => {
    if (!userAddress) {
      try {
        // 1. First check if wallet is connected without forcing permissions
        const activeAccount = await wallet.client.getActiveAccount();

        if (!activeAccount) {
          // 2. Only request permissions if no active account exists
          await wallet.requestPermissions({
            forcePermissionRequest: true, // Ensures modal shows
          });
        }

        // 3. Get address after successful connection
        const address = await wallet.getPKH();
        setUserAddress(address);
        localStorage.setItem("walletAddress", address);
        if (nft?.blockchain_metadata.owner === address) {
          toastRef.current.addToast(
            "Oops! You already own this artwork — making an offer isn’t necessary.",
            "error"
          );

          window.location.reload();
        } else {
          setSelectedNFT(nft);
          setshowMakeModal(true);
        }
      } catch (error) {
        console.error("Connection error:", error);
        toastRef.current.addToast(
          "Failed to connect wallet. Please try again.",
          "error"
        );
      }
      return;
    } else {
      setSelectedNFT(nft);
      setshowMakeModal(true);
    }
  };

  const handleFollowToggle = async (ownerAddress) => {
    if (!userAddress) {
      try {
        // 1. First check if wallet is connected without forcing permissions
        const activeAccount = await wallet.client.getActiveAccount();

        if (!activeAccount) {
          // 2. Only request permissions if no active account exists
          await wallet.requestPermissions({
            forcePermissionRequest: true, // Ensures modal shows
          });
        }

        // 3. Get address after successful connection
        const address = await wallet.getPKH();
        setUserAddress(address);
        localStorage.setItem("walletAddress", address);
        const path = isFollowing
          ? `${domainpath}/api/follow/unfollow`
          : `${domainpath}/api/follow/`;
        const response = await fetch(path, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            follower: address,
            following: ownerAddress,
          }),
        });

        if (response.ok) {
          socket.emit("follow-user", {
            followerWallet: address,
            followerName: address,
            followedWallet: ownerAddress,
            timestamp: new Date().toISOString(),
          });
          isFollowing
            ? toastRef.current.addToast(
                "User UnFollowed Successfully",
                "success"
              )
            : toastRef.current.addToast(
                "User Followed Successfully",
                "success"
              );
          setIsFollowing((prev) => !prev);
        }
      } catch (error) {
        console.error("Connection error:", error);
        toastRef.current.addToast(
          "Failed to connect wallet. Please try again.",
          "error"
        );
      }
      return;
    } else {
      const path = isFollowing
        ? `${domainpath}/api/follow/unfollow`
        : `${domainpath}/api/follow/`;
      const response = await fetch(path, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          follower: userAddress,
          following: ownerAddress,
        }),
      });
      if (response.ok) {
        socket.emit("follow-user", {
          followerWallet: userAddress,
          followerName: userAddress,
          followedWallet: ownerAddress,
          timestamp: new Date().toISOString(),
        });
        isFollowing
          ? toastRef.current.addToast("User UnFollowed Successfully", "success")
          : toastRef.current.addToast("User Followed Successfully", "success");
        setIsFollowing((prev) => !prev);
      }
    }
  };

  const generateAvatar = (address) => {
    return `${process.env.REACT_APP_GENERATE_AVATAR_URL}/${address}.png?size=28x28`;
  };

  const toTez = (mutez) => mutez / 1000000;

  useEffect(() => {
    if (!nfts || !Array.isArray(nfts)) return;

    const offers = nfts.filter(
      (nft) =>
        nft.blockchain_metadata?.open_to_offers &&
        !nft.blockchain_metadata?.open_to_auction
    );

    const auctions = nfts.filter(
      (nft) =>
        nft.blockchain_metadata?.open_to_auction || nft.auctionDetails?.isActive
    );

    setSellerData((prev) => ({
      ...prev,
      offers,
      auctions,
    }));
  }, [nfts]);

  const handlePageChange = (tab, page) => {
    setCurrentPage((prev) => ({ ...prev, [tab]: page }));
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  const renderPagination = (items, tab) => {
    const totalPages = Math.ceil(items.length / ITEMS_PER_PAGE);
    if (totalPages <= 1) return null;

    return (
      <div className="flex justify-center mt-6">
        <nav className="flex items-center space-x-2">
          <button
            onClick={() => handlePageChange(tab, currentPage[tab] - 1)}
            disabled={currentPage[tab] === 1}
            className="px-3 py-1 rounded border border-gray-300 disabled:opacity-50"
          >
            Previous
          </button>
          {Array.from({ length: totalPages }, (_, i) => i + 1).map((page) => (
            <button
              key={page}
              onClick={() => handlePageChange(tab, page)}
              className={`px-3 py-1 rounded ${
                currentPage[tab] === page
                  ? "bg-indigo-600 text-white"
                  : "border border-gray-300"
              }`}
            >
              {page}
            </button>
          ))}
          <button
            onClick={() => handlePageChange(tab, currentPage[tab] + 1)}
            disabled={currentPage[tab] === totalPages}
            className="px-3 py-1 rounded border border-gray-300 disabled:opacity-50"
          >
            Next
          </button>
        </nav>
      </div>
    );
  };

  const getPaginatedItems = (items, tab) => {
    const startIndex = (currentPage[tab] - 1) * ITEMS_PER_PAGE;
    return items.slice(startIndex, startIndex + ITEMS_PER_PAGE);
  };

  const renderMedia = (nft) => {
    const imageUrl = nft.blockchain_metadata.ipfs_url?.replace(
      "ipfs://",
      "https://ipfs.io/ipfs/"
    );
    const mimeType = nft.blockchain_metadata.mime_type;

    if (mimeType?.startsWith("image/")) {
      return (
        <img
          src={imageUrl || "/img/collections/default.jpg"}
          alt={nft.blockchain_metadata.name || "NFT"}
          className="lazy object-cover h-80 w-full transition-transform duration-300 ease-in-out group-hover:scale-105"
        />
      );
    } else if (mimeType?.startsWith("video/")) {
      return (
        <video
          controls
          className="lazy object-cover h-80 w-full transition-transform duration-300 ease-in-out group-hover:scale-105"
        >
          <source src={imageUrl} type={mimeType} />
          Your browser does not support the video tag.
        </video>
      );
    } else if (mimeType?.startsWith("audio/")) {
      return (
        <div className="w-full h-80 flex items-center justify-center bg-gray-100 music_nft">
          <audio controls>
            <source src={imageUrl} type={mimeType} />
            Your browser does not support the audio element.
          </audio>
        </div>
      );
    } else if (
      mimeType === "model/gltf-binary" ||
      mimeType === "model/gltf+json"
    ) {
      return (
        <div className="w-full h-48 flex items-center justify-center bg-black text-white">
          <p>3D Model (GLTF)</p>
        </div>
      );
    } else {
      return (
        <div className="w-full h-48 flex items-center justify-center bg-gray-100">
          <p>Unsupported Media Type</p>
        </div>
      );
    }
  };

  const renderNFTs = (nfts, showCreator = false) => {
    if (loading) {
      return (
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6">
          {[...Array(ITEMS_PER_PAGE)].map((_, i) => (
            <div
              key={i}
              className="border rounded-lg overflow-hidden bg-white animate-pulse"
            >
              <div className="w-full h-48 bg-gray-200"></div>
              <div className="p-4 space-y-2">
                <div className="h-4 bg-gray-200 rounded w-3/4"></div>
                <div className="h-3 bg-gray-200 rounded w-1/2"></div>
              </div>
            </div>
          ))}
        </div>
      );
    }

    if (nfts.length === 0) {
      return (
        <div className="text-center py-12">
          <p className="text-gray-500">No items found</p>
        </div>
      );
    }

    return (
      <>
        <div className="flex flex-wrap">
          {getPaginatedItems(nfts, activeTab).map((nft) => {
            const price = toTez(nft.blockchain_metadata.price || 0);
            const address = showCreator
              ? nft.blockchain_metadata.owner
              : nft.blockchain_metadata.owner;
            const isAuctionActive = nft.auctionDetails?.isActive;
            const auctionEnded = nft.auctionDetails?.end_time;
            const isOwner =
              !!userAddress &&
              nft.blockchain_metadata?.owner?.toLowerCase() ===
                userAddress.toLowerCase();
            const editionNumber = nft.blockchain_metadata.edition || 1;
            const totalSupply = nft.blockchain_metadata.total_supply || 1;
            const currentBid = toTez(nft?.auctionDetails?.highest_bid || 0);
            const totalBidders = nft?.auctionDetails?.highest_bidder || 0;

            return (
              <div
                key={nft.id}
                className="p-2 w-full sm:w-1/2 md:w-1/3 lg:w-1/4"
              >
                <div className="nft__item m-0 h-full min-h-[490px] max-h-[425px] flex flex-col justify-between">
                  {nft?.auctionDetails?.end_time &&
                  new Date(nft.auctionDetails.end_time) > new Date() ? (
                    <div className="de_countdown">
                      <Clock
                        deadline={formatDate(
                          new Date(nft.auctionDetails.end_time)
                        )}
                      />
                    </div>
                  ) : null}

                  <div className="relative author_list_pp">
                    <span>
                      <img
                        className="lazy"
                        src={
                          nft?.blockchain_metadata?.owner_profile
                            .profileImage || generateAvatar(address)
                        }
                        alt=""
                      />
                      <i className="fa fa-check"></i>
                    </span>
                  </div>

                  <div className="nft__item_first">
                    <div
                      className={
                        nft.blockchain_metadata.mimeType?.startsWith("audio/")
                          ? "music_nft nft__item_wrap group relative h-72 sm:h-72 md:h-72 lg:h-72 xl:h-80 overflow-hidden"
                          : "nft__item_wrap group relative h-72 sm:h-72 md:h-72 lg:h-72 xl:h-80 overflow-hidden"
                      }
                      onClick={(e) => navigate(`/art/${nft?.id}`)}
                    >
                      {renderMedia(nft, true)}
                    </div>
                  </div>

                  <div className="nft__item_info flex flex-col gap-1 w-full ">
                    <div
                      className="nft__item_title cursor-pointer"
                      onClick={(e) => navigate(`/art/${nft?.id}`)}
                    >
                      <h4 className="text-base font-semibold">
                        {nft.blockchain_metadata.name || `NFT #${nft.id}`}
                      </h4>
                    </div>

                    <span className="text-gray-500 text-sm">
                      Edition {editionNumber} of {totalSupply}
                    </span>

                    <div>
                      {isAuctionActive ? (
                        nft.auctionDetails?.highest_bid > 0 ? (
                          <div className="text-gray-600 font-semibold">
                            Current Bid: {toTez(nft.auctionDetails.highest_bid)}{" "}
                            ꜩ
                          </div>
                        ) : (
                          <div className="text-gray-600 font-semibold">
                            Opening Bid: {price} ꜩ
                          </div>
                        )
                      ) : nft.blockchain_metadata.open_to_offers ? (
                        <>
                          <span className="text-gray-600 text-sm font-semibold">
                            {nft.totalBidders > 0
                              ? `Current Offer: ${toTez(nft.currentBid)} ꜩ`
                              : "No Offers Yet"}
                          </span>
                          {nft.totalBidders > 0 && (
                            <span className="ml-2 text-gray-500 text-sm font-medium">
                              ({nft.totalBidders}{" "}
                              {nft.totalBidders === 1 ? "offer" : "offers"})
                            </span>
                          )}
                        </>
                      ) : (
                        <div className="text-gray-600 text-sm font-semibold">
                          Price: {price} ꜩ
                        </div>
                      )}
                    </div>

                    <div className="nft__item_action-main w-full flex flex-wrap gap-1 items-start">
                      {isAuctionActive && !auctionEnded && !isOwner && (
                        <div className="nft__item_action">
                          <span
                            onClick={() => openBidModal(nft)}
                            className="place-btn"
                          >
                            Place Bid
                          </span>
                        </div>
                      )}
                      {!isAuctionActive &&
                        nft.blockchain_metadata.open_to_offers &&
                        !isOwner && (
                          <div className="nft__item_action">
                            <span
                              onClick={() => openMakeofferModal(nft)}
                              className="place-btn"
                            >
                              Make an Offer
                            </span>
                          </div>
                        )}
                      {!isAuctionActive &&
                        nft.blockchain_metadata.open_to_sell &&
                        !isOwner && (
                          <div className="nft__item_action">
                            <span
                              onClick={() => handleBuyNow(nft)}
                              className="place-btn"
                            >
                              Buy Now
                            </span>
                          </div>
                        )}
                      {/* {console.log(nft)} */}
                      {isOwner && !nft.blockchain_metadata.open_to_sell && (
                        <div
                          className="nft__item_action cursor-pointer"
                          onClick={() =>
                            nft.blockchain_metadata.open_to_auction
                              ? handleOpenItem(`/art/${nft?.id}?bids`)
                              : handleOpenItem(`/art/${nft?.id}?offers`)
                          }
                        >
                          <span className="place-btn">
                            {nft.blockchain_metadata.open_to_auction
                              ? "Check Bids"
                              : "Check Offers"}
                          </span>
                        </div>
                      )}
                      <div className="flex items-center gap-3 ml-auto">
                        <div
                          className="nft__item_like cursor-pointer"
                          onClick={() =>
                            toggleLike(
                              nft?.id,
                              nft?.likedByUser,
                              nft.nft_id,
                              nft.blockchain_metadata.owner,
                              nft.blockchain_metadata.name
                            )
                          }
                        >
                          <i
                            className={`fa ${
                              nft?.likedByUser ? "fa-heart" : "fa-heart-o"
                            }`}
                            style={{
                              color: nft?.likedByUser ? "red" : "black",
                            }}
                          ></i>
                          <span>{nft?.likeCount || 0}</span>
                        </div>

                        {!isOwner && (
                          <button
                            onClick={() => handleFollowToggle(address)}
                            className="text-blue-600 hover:text-blue-800 flex items-center gap-1"
                          >
                            {nft.isFollowing ? (
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="16"
                                height="16"
                                viewBox="0 0 640 512"
                              >
                                <path d="M96 128a128 128 0 1 1 256 0A128 128 0 1 1 96 128zM0 482.3C0 383.8 79.8 304 178.3 304l91.4 0C368.2 304 448 383.8 448 482.3c0 16.4-13.3 29.7-29.7 29.7L29.7 512C13.3 512 0 498.7 0 482.3zM472 200l144 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-144 0c-13.3 0-24-10.7-24-24s10.7-24 24-24z" />
                              </svg>
                            ) : (
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="16"
                                height="16"
                                viewBox="0 0 640 512"
                              >
                                <path d="M96 128a128 128 0 1 1 256 0A128 128 0 1 1 96 128zM0 482.3C0 383.8 79.8 304 178.3 304l91.4 0C368.2 304 448 383.8 448 482.3c0 16.4-13.3 29.7-29.7 29.7L29.7 512C13.3 512 0 498.7 0 482.3zM504 312l0-64-64 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l64 0 0-64c0-13.3 10.7-24 24-24s24 10.7 24 24l0 64 64 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-64 0 0 64c0 13.3-10.7 24-24 24s-24-10.7-24-24z" />
                              </svg>
                            )}
                          </button>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
        {renderPagination(nfts, activeTab)}
      </>
    );
  };

  const renderActivity = () => {
    if (loading) {
      return (
        <div className="space-y-4">
          {[...Array(5)].map((_, i) => (
            <div
              key={i}
              className="bg-white rounded-lg shadow-sm p-4 border border-gray-100 animate-pulse"
            >
              <div className="flex items-center space-x-4">
                <div className="h-10 w-10 bg-gray-200 rounded-full"></div>
                <div className="flex-1 space-y-2">
                  <div className="h-4 bg-gray-200 rounded w-3/4"></div>
                  <div className="h-3 bg-gray-200 rounded w-1/2"></div>
                </div>
              </div>
            </div>
          ))}
        </div>
      );
    }

    if (sellerData.activity.length === 0) {
      return (
        <div className="text-center py-12">
          <div className="mx-auto w-24 h-24 text-gray-300 mb-4">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={1}
                d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"
              />
            </svg>
          </div>
          <p className="text-gray-500">No activity yet</p>
        </div>
      );
    }

    return (
      <>
        <div className="space-y-3">
          {getPaginatedItems(sellerData.activity, "activity").map(
            (activity, index) => {
              const date = new Date(activity.timestamp);
              const formattedDate = date.toLocaleDateString("en-GB");
              const formattedTime = date.toLocaleTimeString("en-GB", {
                hour: "2-digit",
                minute: "2-digit",
              });
              const amountInTez = toTez(activity.amount || 0);
              const isIncoming = activity.target?.address === userAddress;
              const counterparty = isIncoming
                ? activity.sender
                : activity.target;

              return (
                <div
                  key={index}
                  className="bg-white rounded-lg shadow-sm p-3 border border-gray-100 hover:shadow-md transition-all"
                >
                  <div className="flex items-start space-x-3">
                    <div
                      className={`p-2 rounded-full ${
                        isIncoming
                          ? "bg-green-100 text-green-600"
                          : "bg-blue-100 text-blue-600"
                      }`}
                    >
                      {isIncoming ? (
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          className="h-5 w-5"
                          fill="none"
                          viewBox="0 0 24 24"
                          stroke="currentColor"
                        >
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth={2}
                            d="M19 14l-7 7m0 0l-7-7m7 7V3"
                          />
                        </svg>
                      ) : (
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          className="h-5 w-5"
                          fill="none"
                          viewBox="0 0 24 24"
                          stroke="currentColor"
                        >
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth={2}
                            d="M5 10l7-7m0 0l7 7m-7-7v18"
                          />
                        </svg>
                      )}
                    </div>
                    <div className="flex-1">
                      <div className="flex justify-between items-start">
                        <div>
                          <h3 className="font-medium text-sm">
                            {isIncoming ? "Received" : "Sent"} {amountInTez} ꜩ
                          </h3>
                          <div className="flex items-center mt-1">
                            <img
                              src={generateAvatar(counterparty?.address || "")}
                              alt="avatar"
                              className="w-5 h-5 rounded-full mr-1"
                            />
                            <span className="text-xs text-gray-600">
                              {counterparty?.alias ||
                                `${counterparty?.address?.slice(
                                  0,
                                  6
                                )}...${counterparty?.address?.slice(-4)}`}
                            </span>
                          </div>
                        </div>
                        <span className="text-xs text-gray-500">
                          {formattedTime}
                        </span>
                      </div>
                      <div className="mt-2 flex justify-between text-xs">
                        <span
                          className={`px-2 py-1 rounded ${
                            activity.status === "applied"
                              ? "bg-green-100 text-green-800"
                              : "bg-yellow-100 text-yellow-800"
                          }`}
                        >
                          {activity.status}
                        </span>
                        <a
                          href={`https://tzkt.io/${activity.hash}`}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="text-blue-600 hover:text-blue-800 flex items-center"
                        >
                          View
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            className="h-3 w-3 ml-1"
                            fill="none"
                            viewBox="0 0 24 24"
                            stroke="currentColor"
                          >
                            <path
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              strokeWidth={2}
                              d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14"
                            />
                          </svg>
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              );
            }
          )}
        </div>
        {renderPagination(sellerData.activity, "activity")}
      </>
    );
  };

  if (loading && !sellerData.name) {
    return (
      <div className="RoadmapSpinnerDiv" id="RoadmapSpinnerDiv">
        <span className="RoadmapSpinner"></span>
      </div>
    );
  }
  const renderMakeOfferModal = () => (
    <div className="bid-modal">
      <div className="bid-modal-content relative">
        <button
          onClick={(e) => setshowMakeModal(false)}
          className="absolute top-3 right-3 text-gray-600 hover:text-red-500 text-lg"
        >
          ✖
        </button>
        <h3>Make Your Offer</h3>
        <div className="bid-modal-inputdiv">
          <input
            type="number"
            value={bidAmount}
            min={0.1}
            onChange={(e) => handleBidChange(e, toTez(selectedNFT.currentBid))}
            placeholder="Enter Offer amount 1 ꜩ or 2.05 ꜩ"
          />
        </div>

        {bidError && selectedNFT.currentBid && (
          <p className="text-red-500 text-sm mt-1 mb-2 text-left">
            Offer amount must be higher than the current offer of{" "}
            {toTez(selectedNFT.currentBid)} ꜩ
          </p>
        )}
        <div className="bid-modal-btnmaindiv">
          <button
            type="btn"
            className="btn-main"
            onClick={(e) => handleMakeOffer(e)}
            disabled={!bidAmount || bidError}
          >
            Submit
          </button>
          <button
            type="btn"
            className="btn-clear"
            onClick={(e) => {
              setshowMakeModal(false);
              setBidError(false);
            }}
          >
            Cancel
          </button>
        </div>
      </div>
    </div>
  );
  const renderPlaceBid = () => (
    <div className="bid-modal">
      <div className="bid-modal-content relative">
        <button
          onClick={(e) => setShowBidModal(false)}
          className="absolute top-3 right-3 text-gray-600 hover:text-red-500 text-lg"
        >
          ✖
        </button>

        <h3>Place Your Bid</h3>

        {selectedNFT.auctionDetails && (
          <div className="auction-info mb-4">
            <p className="text-sm mb-1">
              <strong>Auction ends:</strong>{" "}
              {/* {formatDate(selectedNFT.auctionDetails.end_time)} */}
              {new Date(selectedNFT.auctionDetails.end_time).toLocaleString(
                "en-US",
                {
                  year: "numeric",
                  month: "long",
                  day: "numeric",
                  hour: "2-digit",
                  minute: "2-digit",
                  hour12: true, // set to false for 24h format
                }
              )}
            </p>
            {new Date(selectedNFT.auctionDetails.end_time) > new Date() && (
              <div className="flex flex-col items-center bg-white px-4 py-2 rounded-xl border border-dashed border-indigo-200 shadow-inner">
                <span className="text-xs font-semibold text-indigo-600 uppercase mb-1">
                  Time Remaining
                </span>
                <div className="text-xl font-mono font-bold text-indigo-800 tracking-widest">
                  <Clock deadline={selectedNFT.auctionDetails.end_time} />
                </div>
              </div>
            )}
            {selectedNFT.auctionDetails.highest_bid > 0 ? (
              <p className="text-sm">
                <strong>Last Bid:</strong>{" "}
                {toTez(selectedNFT.auctionDetails.highest_bid)} ꜩ
              </p>
            ) : (
              <p className="text-sm">No bids yet</p>
            )}
          </div>
        )}

        <div className="bid-modal-inputdiv">
          <input
            type="number"
            value={bidAmount}
            min={
              selectedNFT.auctionDetails?.highest_bid
                ? toTez(selectedNFT.auctionDetails.highest_bid) + 1
                : 0.1
            }
            step="0.1"
            onChange={(e) => {
              const value = e.target.value;
              setBidAmount(value);

              // Validate bid is higher than current
              const currentBid = selectedNFT.auctionDetails?.highest_bid
                ? toTez(selectedNFT.auctionDetails.highest_bid)
                : 0;
              setBidError(parseFloat(value) <= currentBid);
            }}
            placeholder={
              selectedNFT.auctionDetails?.highest_bid
                ? `Enter bid (min ${(
                    toTez(selectedNFT.auctionDetails.highest_bid) + 0.1
                  ).toFixed(1)} ꜩ)`
                : "Enter bid (min 0.1 ꜩ)"
            }
          />
        </div>

        {bidError && (
          <p className="text-red-500 text-sm mt-1 mb-2 text-left">
            Bid must be higher than current highest bid
          </p>
        )}

        <div className="bid-modal-btnmaindiv">
          <button
            type="btn"
            className="btn-main"
            onClick={handlePlaceBid}
            disabled={!bidAmount || bidError}
          >
            Submit
          </button>
          <button
            type="btn"
            className="btn-clear"
            onClick={(e) => setShowBidModal(false)}
          >
            Cancel
          </button>
        </div>
      </div>
    </div>
  );
  return (
    <>
      <section className="jumbotron breadcumb no-bg">
        <div className="mainbreadcumb">
          <div className="container">
            <div className="row">
              <div className="col-md-12">
                <div className="d_profile de-flex">
                  <div className="de-flex-col">
                    <div className="profile_avatar">
                      {sellerData?.avatar ? (
                        <>
                          <img src={sellerData?.avatar} alt="" />
                          <i className="fa fa-check"></i>
                        </>
                      ) : (
                        ""
                      )}
                      {/* {console.log(sellerData)} */}
                      {sellerData?.name ? (
                        <div className="profile_name">
                          <h4>
                            {sellerData.name}
                            {/* <span className="profile_username">@monicaaa</span> */}
                          </h4>
                          <span id="wallet" className="profile_wallet">
                            {userAddress}
                          </span>
                          <button
                            onClick={() =>
                              navigator.clipboard.writeText(userAddress)
                            }
                            //className="opacity-0 group-hover:opacity-100 transition-opacity duration-200"
                            title="Copy Wallet Address"
                          >
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="16"
                              height="16"
                              viewBox="0 0 16 16"
                            >
                              <path d="M10 1H2a1 1 0 0 0-1 1v11h1V2h8V1z" />
                              <path d="M13 3H5a1 1 0 0 0-1 1v11a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1V4a1 1 0 0 0-1-1zm0 1v11H5V4h8z" />
                            </svg>
                          </button>
                        </div>
                      ) : (
                        ""
                      )}
                    </div>
                  </div>
                  <div className="profile_follow de-flex">
                    <div className="de-flex-col">
                      <div className="profile_follower">
                        {sellerData?.followers
                          ? sellerData?.followers + "  followers"
                          : ""}
                      </div>
                    </div>
                    {/* {!userAddress ? (
                      <div className="de-flex-col">
                        <span className="btn-main">Follow</span>
                      </div>
                    ) : (
                      ""
                    )} */}
                  </div>
                </div>
              </div>
            </div>

            <div className="">
              <ul className="de_nav text-left">
                {[
                  {
                    id: "created",
                    label: "Created",
                    //  count: sellerData.createdItems.length,
                  },
                  {
                    id: "onsale",
                    label: "On Sale",
                    // count: sellerData.createdItems.length,
                  },
                  {
                    id: "liked",
                    label: "Liked",
                    // count: sellerData.createdItems.length,
                  },
                  // {
                  //   id: "owned",
                  //   label: "Owned",
                  //   count: sellerData.ownedItems.length,
                  // },
                  // {
                  //   id: "collections",
                  //   label: "Collections",
                  //   count: sellerData.collections.length,
                  // },
                  // {
                  //   id: "activity",
                  //   label: "Activity",
                  //   count: sellerData.activity.length,
                  // },
                  // {
                  //   id: "offers",
                  //   label: "Offers",
                  //   count: sellerData.offers.length,
                  // },
                  // {
                  //   id: "listings",
                  //   label: "Listings",
                  //   count: sellerData.listings.length,
                  // },
                  // {
                  //   id: "auctions",
                  //   label: "Auctions",
                  //   count: sellerData.auctions.length,
                  // },
                ].map((tab) => (
                  <li
                    key={tab.id}
                    className={`cursor-pointer rounded-t-md ${
                      activeTab === tab.id
                        ? "active font-semibold border-black"
                        : "text-gray-500 hover:text-black"
                    }`}
                    onClick={() => setActiveTab(tab.id)}
                  >
                    <span className="flex items-center  text-sm">
                      {tab.label}
                      {/* {tab.count > 0 && (
                        <div
                          className={`inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium ml-2${
                            activeTab === tab.id
                              ? " bg-white text-black"
                              : " bg-black text-white"
                          }`}
                        >
                          {tab.count}
                        </div>
                      )} */}
                    </span>
                  </li>
                ))}
              </ul>
            </div>

            {/* Content Section */}
            <div className="">
              {activeTab === "created" && (
                <div>
                  {/* <h2 className="text-lg font-semibold mb-4">Created Items</h2> */}
                  {renderNFTs(sellerData.createdItems, true)}
                </div>
              )}

              {activeTab === "onsale" && (
                <div>
                  <h2 className="text-lg font-semibold mb-4">On Sale</h2>
                  {renderNFTs(sellerData?.onsale)}
                </div>
              )}
              {activeTab === "owned" && (
                <div>
                  {/* <h2 className="text-lg font-semibold mb-4">Owned Items</h2> */}
                  {renderNFTs(sellerData.ownedItems)}
                </div>
              )}
              {activeTab === "liked" && (
                <div>
                  {/* <h2 className="text-lg font-semibold mb-4">Owned Items</h2> */}
                  {renderNFTs(sellerData.liked)}
                </div>
              )}
              {activeTab === "collections" && (
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 py-8">
                  {sellerData.collections.length === 0 ? (
                    <div className="col-span-full text-center py-12">
                      <p className="text-gray-500">No collections available</p>
                    </div>
                  ) : (
                    sellerData.collections.map((collection) => (
                      <div
                        key={collection.key}
                        className="bg-white rounded-2xl shadow-md p-4 flex flex-col space-y-4"
                      >
                        <h2 className="text-xl font-semibold text-gray-800">
                          {collection.description}
                        </h2>
                        <div className="grid grid-cols-2 gap-2">
                          {collection.included_nfts.map((nft) => (
                            <div
                              key={nft.key}
                              className="bg-gray-50 rounded-xl overflow-hidden shadow-sm"
                            >
                              <img
                                src={nft.metadata.ipfs_url.replace(
                                  "ipfs://",
                                  "https://ipfs.io/ipfs/"
                                )}
                                alt={nft.metadata.name}
                                className="w-full h-32 object-cover"
                              />
                              <div className="p-2 text-sm text-gray-700 font-medium truncate">
                                {nft.metadata.name}
                              </div>
                            </div>
                          ))}
                        </div>
                      </div>
                    ))
                  )}
                </div>
              )}

              {activeTab === "activity" && (
                <div>
                  <h2 className="text-lg font-semibold mb-4">Activity</h2>
                  {renderActivity()}
                </div>
              )}

              {activeTab === "offers" && (
                <div>
                  <h2 className="text-lg font-semibold mb-4">Offers</h2>
                  {renderNFTs(sellerData.offers)}
                </div>
              )}
              {activeTab === "auctions" && (
                <div>
                  <h2 className="text-lg font-semibold mb-4">Auction</h2>
                  {renderNFTs(sellerData.auctions)}
                </div>
              )}
              {activeTab === "auctions" && (
                <div className="text-center py-12">
                  <p className="text-gray-500">No {activeTab} available</p>
                </div>
              )}
            </div>
          </div>
        </div>
      </section>
      {showMakeModal && renderMakeOfferModal()}
      {showBidModal && selectedNFT?.hasAuction && renderPlaceBid()}

      {loading && (
        <div className="RoadmapSpinnerDiv" id="RoadmapSpinnerDiv">
          <span className="RoadmapSpinner"></span>
        </div>
      )}
      <CustomToastContainer ref={toastRef} />
    </>
  );
};

export default AuthorProfile;
